import { useTheme } from '@emotion/react';
import { FC, useState } from 'react';
import { Document } from 'react-pdf';
import { DocumentCallback } from 'react-pdf/dist/cjs/shared/types';
import { List } from 'react-window';
import { useNavigate } from 'react-router-dom';

import { routes } from 'src/constants/routes';

import { Spinner } from '../spinner';

import { PdfViewerProps } from './types';
import { useGetPageHeight } from './hooks/useGetPageHeights';
import { PdfPage, PdfPageProps } from './pdf-page';

export const PdfViewer: FC<PdfViewerProps> = ({ file, isLoading, name }) => {
    const navigate = useNavigate();
    const [pdf, setPdf] = useState<DocumentCallback | null>(null);
    const { data: pageViewports, error, mutate: getPageHeight, isPending } = useGetPageHeight(name);
    const theme = useTheme();

    if (!file || isLoading) {
        return <Spinner />;
    }

    if (error) {
        navigate(routes.failure.index);
        return null;
    }

    return (
        <Document
            file={file}
            onLoadSuccess={(document) => {
                setPdf(document);
                getPageHeight(document);
            }}
            loading={<Spinner />}
        >
            {pdf && pageViewports && !isPending ? (
                <List<PdfPageProps>
                    rowHeight={(pageIndex) => {
                        const pageViewport = pageViewports[pageIndex];
                        const scale = theme.custom.agreementContainer.width / pageViewport.width;
                        const actualHeight = pageViewport.height * scale;

                        return actualHeight;
                    }}
                    rowComponent={PdfPage}
                    rowCount={pdf.numPages}
                    rowProps={{ pageViewports }}
                    overscanCount={3}
                    style={{
                        height: theme.custom.agreementContainer.height,
                    }}
                />
            ) : null}
        </Document>
    );
};
